"use client"

import { dictionary } from "../../utils/dictionary"
import { useAuth } from "../../context/AuthContext"

interface SwitchTabsProps {
  label: string
  onClick: (type: string) => void
}

export default function SwitchTabs({ label, onClick }: SwitchTabsProps) {
  const { language } = useAuth()

  const tabs = [
    {
      key: "funnels",
      label: dictionary["funnels-label"][language],
    },
    {
      key: "homes",
      label: dictionary["homes-label"][language],
    },
    {
      key: "ab-testing",
      label: dictionary["ab-testing"][language],
    },
  ]

  return (
    <div className="bg-gray-200 rounded-full p-1 flex w-fit">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => {
            onClick(tab.label)
          }}
          className={
            label === tab.label
              ? "px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 bg-white text-gray-900 shadow-sm"
              : "px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 text-gray-500 hover:text-gray-700"
          }
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
